import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { ViteEnv } from '@/env';
import { exchangeCodeForToken } from '@/lib/queries/integrations/scm/github';
import { preLoadDefaultProject } from '@/lib/queries/project';

import { GithubInstallationPending } from './-components/GithubInstallationPending';
import { GITHUB_TOKEN_SESSION_KEY } from './-constants';

export const Route = createFileRoute('/github-callback/authenticated')({
  component: GithubInstallationPending,
  validateSearch: (search: Record<string, unknown>) =>
    z
      .object({
        code: z.coerce.string(),
      })
      .parse(search),
  loaderDeps: ({ search }) => ({ code: search.code }),
  loader: async ({ context, deps: { code } }) => {
    const defaultProject = await preLoadDefaultProject({ context });

    try {
      const githubToken = await exchangeCodeForToken(defaultProject.id, code);

      sessionStorage.setItem(GITHUB_TOKEN_SESSION_KEY, githubToken);
      window.location.href = ViteEnv.VITE_GITHUB_REDIRECT_URL;
    } catch (e) {
      console.error(e);
      context.toast({
        title: 'githubCallback.authenticationError',
        variant: 'destructive',
      });

      throw redirect({ to: '/' });
    }
  },
  pendingComponent: GithubInstallationPending,
});
